import React from 'react';
import {
    MapPin,
    Phone,
    Clock,
    MessageSquare
} from 'lucide-react';

const ContactUs = () => {
    const restaurantInfo = {
        name: "Tandoor Delight",
        address: "Friedrichstraße 123, 10117 Berlin, Germany",
        phone: "+49 30 1234 5678",
        whatsapp: "+49 30 1234 5678",
        hours: [
            { day: "Monday - Friday", time: "11:30 AM - 10:00 PM" },
            // { day: "Saturday - Sunday", time: "12:00 PM - 11:00 PM" }
        ],
        location: {
            lat: 52.520008,
            lng: 13.404954
        }
    };

    return (
        <section id="contact" className="py-8 bg-white">
            <div className="container mx-auto px-4 max-w-5xl">
                {/* Section Header */}
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold text-gray-800">Contact Us</h2>
                    <div className="w-24 h-1 mx-auto mt-3" style={{ backgroundColor: '#7bae37' }}></div>
                    <p className="text-gray-600 mt-4 text-lg">Find us in Berlin</p>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                    {/* Contact Info Card */}
                    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                        <div className="text-white px-6 py-4" style={{ backgroundColor: '#7bae37' }}>
                            <h3 className="font-bold text-2xl">Contact Information</h3>
                        </div>

                        <div className="p-6 space-y-6">
                            {/* Address */}
                            <div className="flex items-start">
                                <MapPin className="mt-1 mr-3 flex-shrink-0" style={{ color: '#7bae37' }} size={20} />
                                <p className="text-gray-800 text-base">
                                    <span className="font-medium">Address:</span> {restaurantInfo.address}
                                </p>
                            </div>

                            {/* Phone */}
                            <div className="flex items-start">
                                <Phone className="mt-1 mr-3 flex-shrink-0" style={{ color: '#7bae37' }} size={20} />
                                <p className="text-gray-800 text-base">
                                    <span className="font-medium">Phone:</span>{' '}
                                    <a
                                        href={`tel:${restaurantInfo.phone}`}
                                        className="transition-colors"
                                        style={{ '&:hover': { color: '#7bae37' } }}
                                    >
                                        {restaurantInfo.phone}
                                    </a>
                                </p>
                            </div>

                            {/* WhatsApp */}
                            <div className="flex items-start">
                                <MessageSquare className="mt-1 mr-3 flex-shrink-0" style={{ color: '#7bae37' }} size={20} />
                                <p className="text-gray-800 text-base">
                                    <span className="font-medium">WhatsApp:</span>{' '}
                                    <a
                                        href={`https://wa.me/${restaurantInfo.whatsapp.replace(/[^0-9]/g, '')}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="transition-colors"
                                        style={{ '&:hover': { color: '#7bae37' } }}
                                    >
                                        {restaurantInfo.whatsapp}
                                    </a>
                                </p>
                            </div>

                            {/* Opening Hours */}
                            <div className="flex items-start">
                                <Clock className="mt-1 mr-3 flex-shrink-0" style={{ color: '#7bae37' }} size={20} />
                                <p className="text-gray-800 text-base">
                                    <span className="font-medium">Opening Hours:</span>{' '}
                                    {restaurantInfo.hours
                                        .map((item) => `${item.day}: ${item.time}`)
                                        .join(', ')}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Google Map */}
                    <div className="rounded-xl overflow-hidden shadow-lg">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2428.654394318313!2d13.387731776602502!3d52.51764037436447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a851c607196a5d%3A0x1b5b20ee43c8d25!2sFriedrichstra%C3%9Fe%2C%20Berlin%2C%20Germany!5e0!3m2!1sen!2sus!4v1713996747958!5m2!1sen!2sus"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Google Map of Tandoor Delight in Berlin"
                            className="w-full h-96"
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactUs;